import { GetStaticProps, NextPage } from 'next';
import React from 'react';
import nameSpacesConfig from '@/config/config.nameSpaces.json';
import { CookiesPage } from '@/containers/CookiesPage/CookiesPage';
import { Footer } from '@/containers/PageLayout/components/Footer/Footer';
import { Navbar } from '@/containers/PageLayout/components/Navbar/Navbar';
import { SideNavbar } from '@/containers/PageLayout/components/SideNavbar';
import { PageLayout } from '@/containers/PageLayout/PageLayout';
import { checkForDefaultLocale } from '@/lib/i18n/checkForDefaultLocale';
import { getServerSideTranslations } from '@/lib/i18n/getServerSideTranslations';
import { PageDataContextProvider } from '@/lib/pageData/pageDataContext';
import { CMSData } from '@/types/CMSData';
import { importCmsJson } from '@/utils/importCmsJson';

interface Props {
  data: CMSData<'default'>;
}

const Cookies: NextPage<Props> = ({ data }) => (
  <>
    <PageDataContextProvider data={data}>
      <PageLayout
        metaTags={{ noindex: true }}
        navBar={<Navbar rightSlot={<SideNavbar />} />}
        footer={<Footer />}
      >
        <CookiesPage />
      </PageLayout>
    </PageDataContextProvider>
  </>
);

export default Cookies;

export const getStaticProps: GetStaticProps<Props> = async ({ locale }) => {
  if (checkForDefaultLocale(locale!)) {
    return {
      notFound: true,
    };
  }

  const data = await importCmsJson(locale!, 'default');

  return {
    props: {
      data,
      ...(await getServerSideTranslations(locale!, [
        nameSpacesConfig.common,
        nameSpacesConfig.pages,
      ])),
    },
  };
};
